var m = require('mithril');
var prop = require('mithril/stream')
var alerts = require('./alerts');

var csrfToken = 'aaaaa';
var cloudIdentitySyncPausedMessage = 'Nimrod Cloud identity synchronization is temporarily unavailable. Access is paused for safety.';

var xhrConfig = function(xhr) {
    xhr.setRequestHeader('X-CSRFToken', csrfToken);
}

var loaders = {};

function cloudIdentitySyncIsPaused(error) {
  var response = error && error.response;
  var status = error && (error.code || error.status);
  var message = response && typeof response === 'object'
    ? response.error
    : (typeof response === 'string' ? response : (error && error.message));

  return Number(status) === 503 && message === cloudIdentitySyncPausedMessage;
}

function redirectToLoginWhenCloudIdentitySyncIsPaused(error) {
  if (!cloudIdentitySyncIsPaused(error) || typeof window === 'undefined' || !window.location) {
    return false;
  }

  // The server has already cleared the stale session. Reload through the
  // server route so the cached SPA cannot continue to look authenticated.
  window.location.href = '/';
  return true;
}

function responseWithStatus(error) {
  var response = error && error.response;
  if (!response || typeof response !== 'object') return response || error;

  // Most callers use the response body as their error object. Preserve the
  // HTTP status there as well so a page can render the correct recovery state
  // without losing the server's validation/error fields.
  if (
    response.status == null &&
    response.statusCode == null &&
    response.code == null &&
    Number.isFinite(Number(error.code))
  ) {
    response.status = Number(error.code);
  }
  return response;
}

loaders.Loader = {
  start: function () {
      this.queue(this.queue() + 1);
  },
  stop: function () {
      this.queue(this.queue() > 0 ? this.queue() - 1 : 0);
  },
  show: function () {
      return this.queue() > 0
  }
};

loaders.main = Object.create(loaders.Loader);
loaders.main.queue = prop(0);


loaders.submit = Object.create(loaders.Loader);
loaders.submit.queue = prop(0);

loaders.background = Object.create(loaders.Loader);
loaders.background.queue = prop(0);

loaders.transfer = Object.create(loaders.Loader);
loaders.transfer.queue = prop(0);
loaders.transfer.label = prop('');
loaders.transfer.progress = prop(null);
loaders.transfer.jobUid = prop('');
loaders.transfer.cancelEndpoint = prop('');
loaders.transfer.canceling = prop(false);
loaders.transfer.setState = function (label, progress) {
  this.label(typeof label === 'string' ? label : '');
  this.progress(Number.isFinite(Number(progress)) ? Math.round(Number(progress)) : null);
};
loaders.transfer.setCancelable = function (uid, cancelEndpoint) {
  this.jobUid(typeof uid === 'string' ? uid : '');
  this.cancelEndpoint(typeof cancelEndpoint === 'string' ? cancelEndpoint : '');
  this.canceling(false);
};
loaders.transfer.clearCancelable = function () {
  this.jobUid('');
  this.cancelEndpoint('');
  this.canceling(false);
};
loaders.transfer.resetState = function () {
  this.label('');
  this.progress(null);
  this.clearCancelable();
};


loaders.linkWithLoader = function(element, isInitialized, context) {
    if (!isInitialized) {
        element.onclick = function(e) {
            e.preventDefault();
            loaders.main.start();
            m.redraw();
            m.route(element.getAttribute("href"));
        }
    }
};

loaders.requestWithLoader = function (args) {
  var loader = loaders[args['loader']] || loaders.main;
  delete args['loader'];
  loader.start();

  if (args.body == null && args.data != null) {
    var method = String(args.method || 'GET').toUpperCase();
    if (method === 'GET' || method === 'HEAD') {
      args.params = args.params != null ? args.params : args.data;
    } else {
      args.body = args.data;
    }
    delete args.data;
  }

  args['config'] = xhrConfig;
  return m.request(args)
  .then(function(data) {
    loader.stop();
    return data
  })
  .catch(function(error){
    console.error(error);
    loader.stop();
    redirectToLoginWhenCloudIdentitySyncIsPaused(error);
    throw responseWithStatus(error);
  });
};

loaders.cloudIdentitySyncIsPaused = cloudIdentitySyncIsPaused;

module.exports = loaders;
